import { AppBar, Grid, Theme, Toolbar, Typography } from '@mui/material';

const ROOT_STYLE = {
    top: 'auto',
    bottom: 0,
    zIndex: (theme: Theme) => theme.zIndex.drawer - 10
}

export const Footer = () => {
    return (
        <AppBar position="static" component="footer" sx={ROOT_STYLE}>
            <Toolbar sx={{ minHeight: 42 }}>
                <Grid container direction="column" justifyContent="center" alignItems="center" >
                    <Typography variant="caption" fontSize={10}>当ホームページ掲載の記事、写真、イラスト等の無断掲載を禁止します</Typography>
                    <Typography variant="caption" fontSize={10}>©2022 Bombers. All Rights Reserved.</Typography>
                </Grid>
            </Toolbar>
        </AppBar>
    )
}
